import { render, staticRenderFns } from "./change-phone.vue?vue&type=template&id=0b78f900&scoped=true"
import script from "./change-phone.vue?vue&type=script&lang=js"
export * from "./change-phone.vue?vue&type=script&lang=js"
import style0 from "./change-phone.vue?vue&type=style&index=0&id=0b78f900&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78f900",
  null
  
)

export default component.exports